import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dealerWebsite",
})
export class DealerWebsitePipe implements PipeTransform {
  transform(value: string): string {
    if (value.startsWith("www.")) {
      return `http://${value.replace("www.", "")}`;
    }

    return value;
  }
}
